
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DotsVerticalIcon from "@/components/icons/DotsVerticalIcon.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import ClickOutside from "vue-click-outside";

  @Component({
    components: {
      UiButton,
      DotsVerticalIcon,
    },
    directives: {
      ClickOutside,
    },
  })
  export default class ButtonDropdown extends Vue {
    @Prop({ type: Boolean, default: false }) readonly value!: boolean;
    windowWidth: any = null;
    showDropdown: boolean = false;

    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }

    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth > 1024) {
        this.showDropdown = false;
      }
    }

    get dropdownMode(): boolean {
      return this.windowWidth < 1024;
    }

    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
    
    hideDropdown() {
      if (!this.dropdownMode) {
        return;
      }
      this.showDropdown = false;
    }
    
    get slotClass(): string {
      if (!this.dropdownMode) {
        return "noDropdownStyle";
      }
      if (this.dropdownMode && !this.showDropdown) {
        return "hideDropdown";
      }
      if (this.dropdownMode && this.showDropdown) {
        return "showDropdown";
      }
      return "";
    }
  }
